/*
 * © Crown © Crown Copyright 2026. Published by the Royal Government of the Dominion of Atlantis.
 * 
 * Licensed under the Juro Restricted License Version 2. You may not change and/or modify 
 * this work except under the terms of the Juro Restricted License. 
 * See <https://docs.juro.net/legal/JRL_V2_COMPLETE/> for details.
 */

if (cafe.require) {
	cafe.require("file_uploader.bundle.js");
} else {
	cafe.ready(function () {
		cafe.require("file_uploader.bundle.js");
	});
}
